import mailTrashService from '../../../services/mailTrash.service'

export default {
    async getListMailTrash({dispatch, commit}, data) {
        return await mailTrashService.getListMailTrash(data)
            .then(response => {
                if (response.success && response.data) {
                    const listMailTrash = response.data.data
                    commit("SET_LIST_MAIL_TRASH", listMailTrash)
                    return Promise.resolve(response.data);
                } else {
                    commit("SET_LIST_MAIL_TRASH", [])
                    dispatch("alertError", response.message, { root: true });
                    return Promise.reject(response.message);
                }
            }).catch(error => {
                commit("SET_LIST_MAIL_TRASH", [])
                return Promise.reject(false);
            })
    },
    getTrashMailDetail({ dispatch, commit }, data) {
        return mailTrashService.getTrashMailDetail(data)
            .then(response => {
                if (response.success && response.data) {
                    return Promise.resolve(response.data);
                } else {
                    dispatch("alertError", response.message, { root: true });
                }
            }).catch(error => {
                dispatch("alertError", error, {root: true});
                return Promise.reject(false);
            });
    },
    async restoreMailTrash({commit, dispatch}, data){
        return mailTrashService.restoreMailTrash(data)
            .then(response => {
                const message = typeof response.message === 'object' ? response.message[0] : response.message;

                if (response.success && response.data) {
                    dispatch("alertSuccess", message, { root: true });
                    return Promise.resolve(response.data);
                } else {
                    dispatch("alertError", message, { root: true });
                }
            }).catch(error => {
                error = error.response;
                const message = (error && error.data && error.data.message) || error.statusText;
                dispatch("alertError", message, {root: true});
                return Promise.reject(false);
            });
    },
    async deletePermanentlyMailTrash({commit, dispatch}, data){
        return mailTrashService.deletePermanentlyMailTrash(data)
            .then(response => {
                const message = typeof response.message === 'object' ? response.message[0] : response.message;

                if (response.success && response.data) {
                    dispatch("alertSuccess", message, { root: true });
                    return Promise.resolve(response.data);
                } else {
                    dispatch("alertError", message, { root: true });
                }
            }).catch(error => {
                error = error.response;
                const message = (error && error.data && error.data.message) || error.statusText;
                dispatch("alertError", message, {root: true});
                return Promise.reject(false);
            });
    },
    clearSearchFilter({commit}){
        commit('CLEAR_SERACH_FILTER')
    },
    setMode ({dispatch ,commit}){
      commit('SET_MODE');
    },
}